
import React from 'react';

const hStyle = { color: 'cyan' };

export default function About() {
  return (
    <>
      <div className="container my-5">
        <h3 className="text-white"> Discover More🥤</h3>
        <div className="accordion accordion-flush my-2" id="accordionFlushExample">
          <div className="accordion-item my-2">
            <h2 className="accordion-header" id="flush-headingOne">
              <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseOne" aria-expanded="false" aria-controls="flush-collapseOne">
                About FireCart 🔥
              </button>
            </h2>
            <div id="flush-collapseOne" className="accordion-collapse collapse" aria-labelledby="flush-headingOne" data-bs-parent="#accordionFlushExample">
              <div className="accordion-body">FireCart is a fully functioning Shopping App with functionalities including cart, checkout, type-form(checkout), search query(upcoming), Transactions and amazing quirks!</div>
            </div>
          </div>
          <div className="accordion-item">
            <h2 className="accordion-header" id="flush-headingTwo">
              <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseTwo" aria-expanded="false" aria-controls="flush-collapseTwo">
                Built With 🛠
              </button>
            </h2>
            <div id="flush-collapseTwo" className="accordion-collapse collapse" aria-labelledby="flush-headingTwo" data-bs-parent="#accordionFlushExample">
              <div className="accordion-body">FireCart is the improved version of the old FireCart project which I built earlier, <a href="https://firecart.netlify.app/"><u>Find it here!</u></a>
                🔗 The improved edition uses React.js, Commerce.js, Bootstrap for few components, Stripe(For Transactions) and Firebase in the Backend.
                Uses React-Router DOM for UI sync. Site Hosted using Netlify.
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="flex justify-center items-center flex-col mt-5">
        <p className="text-white text-sm text-center">Reach out for more!</p>
        <p className="text-white text-sm text-center font-medium mt-2">12shreyashh@gmail.com &emsp; <a style={hStyle} href="https://github.com/shr3yash"><u>Shr3yash on GitHub</u></a>🌐</p>
      </div>

      <div className="sm:w-[90%] w-full h-[0.25px] bg-white mt-5 " />
      <div className="sm:w-[90%] w-full flex justify-between items-center mt-3">
        <p className="text-white text-left text-xs">©shrysh</p>
        <p className="text-white text-right text-xs">Version : v.o1.2o2o</p>
      </div>
    </>
  );
}
